import HomeTechnologies from './HomeTechnologies'

export default HomeTechnologies